<template>
  <div elevation="0">
    <div max-width="1024px" class="ma-auto" elevation="0">
      <v-row class="" elevation="0">
        <div
          class="d-flex col-12 col-sm-6 col-md-6"
          v-for="item in data['answers']"
          :key="item['id']">
          <div class="question-item__wrapper"
            :class="{
              'active': typeof arr == 'string' 
              ? arr[0] == item.id
              : arr.filter(e=>{return e == item.id}).length
            }">
            <div class="question-item__checkboxs" v-if="data['answers'].filter(e=>{return e.is_true}).length > 1">
              <label class="question-item__label">
                <v-checkbox
                  v-model="arr"
                  :label="item['title']"
                  color="orange"
                  :value="item['id']"
                  hide-details>
                  <template #label v-if="item['img']">
                      <div
                        class="text-center"
                        width="100%"
                        elevation="0"
                        color="transparent"
                      >
                        <div class="question__title m-b-3 ta-left">
                          <span v-html="$options.filters.mathformat(item['title'])"></span>
                        </div>
                        <div class="question__img-content">
                          <img :src="item['img']" width="100%" alt="" />
                        </div>
                      </div>
                    </template>
                    <template #label v-else>
                      <span v-html="$options.filters.mathformat(item['title'])"></span>
                    </template>
                </v-checkbox>
              </label>
            </div>
            <div class="question-item__radios" v-else>
              <label class="question-item__label">
                <v-radio-group v-model="arr[0]">
                  <v-radio
                    class="pa-0 ma-0"
                    :label="item['title']"
                    color="orange"
                    :value="item['id']"
                    hide-details
                  >
                    <template #label v-if="item['img']">
                      <div
                        class="text-center box-xs-10"
                      >
                        <div class="question__title m-b-3 ta-left">
                          <span v-html="$options.filters.mathformat(item['title'])"></span>
                        </div>
                        <div class="question__img-content">
                          <img :src="item['img']" width="100%" alt="" />
                        </div>
                      </div>
                    </template>
                    <template #label v-else>
                      <span v-html="$options.filters.mathformat(item['title'])" class="pr-8"></span>
                    </template>
                  </v-radio>
                </v-radio-group>
              </label>
            </div>
          </div>
        </div>
      </v-row>
      <div class="ta-center m-t-10 btn-content">
        <v-btn :loading="loading" @click="answer" class="mt-8" large color="info">
          Ответить на вопрос
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>


export default {
  props: {
    data: Object,
  },
  data() {
    return {
      isPlaying: false,
      track: null,
      arr: [],
      radioBtn: null,
      currentAudio: null,
      loading: false,
    };
  },
  created() {

  },
  mounted(){
    
  },
  methods: {
    isEnded() {
      this.isPlaying = false;
    },
    play(item, arrItems) {
      let audio = item.audio_document
      arrItems.forEach((el)=>{
        if(el.track)
          el.track.pause()
        el.audio_document.play = false
      })
      audio.play = true;
      item.track = new Audio(audio.file);
      
      item.track.play();
      console.log(document.querySelectorAll("audio"))
      item.track.onended = function () {
        audio.play = false;
      };
    },
    pause(item) {
      let audio = item.audio_document
      audio.play = false;
      item.track.pause();
    },
    async answer() {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 500);
    },
  },
  beforeDestroy() {
    if (this.track) {
      this.track.pause();
    }
  },
};
</script>
